import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.6 9.985h-1.584v-.748H11.6zM17.823 3q-4.701 0-9.402.002-.216 0-.43.028c-1.51.19-2.674 1.387-2.783 2.858-.109 1.466.858 2.81 2.318 3.208.28.076.572.106.886.161v2.306h1.58v2.313H3.594v-1.53H2v3.907c0 .25.007.498.01.747h1.577v-1.56h8.029v-3.888h1.594V9.218h3.215V4.553H18V3z"
    }, null, -1)
  ])))
}
export default { render: render }